import { combineReducers } from 'redux';
import initData from './init-data';
import ui from './ui';
import items from './items';
import search from './search';
import multiCurrency from './multi-currency';
import page from './page';
import ads from './ads';
import categories from './categories';

export default combineReducers({
    ads,
    categories,
    initData,
    items,
    multiCurrency,
    page,
    search,
    ui
});



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/state/reducers/index.js